import HelmetUTP from "components/HelmetUTP/HelmetUTP";

const ResourceHelmet = ({ title }) => {
	return (
        <HelmetUTP title={`Recursos - ${title}`}/>
	);
}

export default ResourceHelmet;